<template>
	<div></div>
</template>

<script>
	import {post,get} from '../util/util'

    export default{
        data(){
            return{
              authForm:null
            }
        },
        created(){
          let form= window.sessionStorage.getItem("ca_pay_authForm")
          if(form){
            this.authForm = JSON.parse(form)
          }
        },
        mounted(){
            post('pp/queryprice',this.authForm).then(res=>{
              this.$router.replace({name:'queryresult',params:{info:JSON.stringify(res)}})
            })
        },
        methods:{
        }
    }
</script>


<style scoped>
.info-item {
  margin: 15px 0;
  padding: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;

}

.info-item label {
  color: #080808;
}


.info-item span {
  color: #666;
  font-size: small;
}
</style>